// v6 F9.8 — Wraps protected routes. Redirects to /login if no user.
// v6 F11   — Max-wait timer: als auth.loading > 12s blijft hangen
//            (netwerkprobleem), tonen we een fallback i.p.v. eindeloos
//            "Laden…". Voorkomt het "blanke scherm"-symptoom op iPhone.

import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { describeAuthError } from "../lib/authFetch";

const MAX_LOADING_MS = 12000;

export default function ProtectedRoute({ children, adminOnly = false }) {
  const { user, loading, networkError, refresh } = useAuth();
  const [stuck, setStuck] = React.useState(false);

  React.useEffect(() => {
    if (!loading) {
      setStuck(false);
      return;
    }
    const t = setTimeout(() => setStuck(true), MAX_LOADING_MS);
    return () => clearTimeout(t);
  }, [loading]);

  if (loading && !stuck) {
    return (
      <div className="min-h-screen bg-[#FAF9F6] flex items-center justify-center" data-testid="auth-loading">
        <div className="text-center">
          <span className="inline-block w-6 h-6 border-2 border-[#D96C4A] border-t-transparent rounded-full animate-spin mb-3" />
          <div className="text-sm text-[#5D7259] uppercase tracking-[0.2em]">
            Laden…
          </div>
        </div>
      </div>
    );
  }

  if (loading && stuck) {
    // Network-stuck fallback
    return (
      <div className="min-h-screen bg-[#FAF9F6] flex items-center justify-center px-5" data-testid="auth-stuck">
        <div className="w-full max-w-md bg-white border border-[#E5E2DC] rounded-2xl p-8 text-center">
          <div className="text-sm uppercase tracking-[0.2em] font-bold text-[#D9534F]">
            Geen verbinding
          </div>
          <div className="font-heading text-lg text-[#2C2C2A] mt-2 leading-snug">
            {networkError
              ? describeAuthError(networkError)
              : "De server reageert traag. Probeer opnieuw."}
          </div>
          <button
            onClick={() => { setStuck(false); refresh(); }}
            className="mt-5 w-full h-12 rounded-xl bg-[#D96C4A] hover:bg-[#C05A3C] text-white font-medium"
            data-testid="auth-retry-btn"
          >
            Opnieuw proberen
          </button>
          <a
            href="/login"
            className="block mt-3 text-sm text-[#5D7259] underline"
            data-testid="auth-go-login"
          >
            Terug naar inlogscherm
          </a>
        </div>
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}
